import * as React from 'react';
import {createViewConfig} from '@sail/engine';
import {tokens as $} from '@sail/tokens';
import type {View} from '../view';

export const DividerConfig = createViewConfig({
  props: {} as View.IntrinsicElement<'span'>,
  name: 'Divider',
  flattens: true,
});

/**
 * @external
 */
export const Divider = DividerConfig.createView(
  (props) => {
    return <span {...props} role="separator" />;
  },
  {
    css: {
      display: 'block',
      flex: '0 0 1px',
      backgroundColor: $['color.border'],
      alignSelfX: 'stretch',
      alignSelfY: 'stretch',
      paddingLeft: 'space.1',
      paddingTop: 'space.1',
    },
  },
);
